// The data structure of JSON:API model for `devour-client`:
// { resourceName, fields, options }
//
// Note: `id` is not required in field definition
export default [{
  resourceName: 'domain',
  fields: {
    name: '',
    active: true
  },
  options: {
    collectionPath: 'notes/domains',
    type: 'domain'
  }
}, {
  resourceName: 'reference',
  fields: {
    author_name: '',
    reference_id: '',
    reference_domain: {
      jsonApi: 'hasOne',
      type: 'domain'
    },
    reference_label: '',
    reference_path: ''
  },
  options: {
    collectionPath: 'notes/references',
    type: 'reference'
  }
}, {
  resourceName: 'setting',
  fields: {
    author_name: '',
    value: null,
    value_type: ''
  },
  options: {
    collectionPath: 'notes/settings',
    readOnly: ['value_type'],
    type: 'setting'
  }
}, {
  resourceName: 'history',
  fields: {
    date_modified: null,
    modified_by: null,
    type: ''
  },
  options: {
    collectionPath: 'history',
    readOnly: ['date_modified', 'modified_by'],
    type: 'history'
  }
}, {
  resourceName: 'tag',
  fields: {
    author_name: '',
    name: '',
    domain: {
      jsonApi: 'hasOne',
      type: 'domain'
    },
    active: true,
    slug: '',
    date_added: null,
    date_modified: null
  },
  options: {
    collectionPath: 'notes/tags',
    readOnly: ['date_added', 'date_modified'],
    type: 'tag'
  }
}, {
  resourceName: 'note-type',
  fields: {
    author_name: '',
    name: '',
    domain: {
      jsonApi: 'hasOne',
      type: 'domain'
    },
    active: true,
    description: '',
    date_added: null,
    date_modified: null
  },
  options: {
    collectionPath: 'notes/types',
    readOnly: ['date_added', 'date_modified'],
    type: 'note-type'
  }
}, {
  resourceName: 'note',
  fields: {
    author_name: '',
    creator: null,
    title: '',
    body: '',
    date_added: null,
    date_modified: null,
    custom_data: null,
    is_locked: false,
    reference: {
      jsonApi: 'hasOne',
      type: 'reference'
    },
    note_type: {
      jsonApi: 'hasOne',
      type: 'note-type'
    },
    tags: {
      jsonApi: 'hasMany',
      type: 'tag'
    },
    history: {
      jsonApi: 'hasMany',
      type: 'history'
    }
  },
  options: {
    collectionPath: 'notes',
    readOnly: ['creator', 'date_added', 'date_modified'],
    type: 'note'
  }
}]
